/**
 * Generates initials from first and last name
 * @param firstName - User's first name
 * @param lastName - User's last name
 * @returns String of initials (e.g., "JD" for "John Doe")
 */
export const getUserInitials = (firstName?: string, lastName?: string): string => {
  if (!firstName && !lastName) return 'U';
  
  const firstInitial = firstName?.charAt(0).toUpperCase() || '';
  const lastInitial = lastName?.charAt(0).toUpperCase() || '';
  
  return `${firstInitial}${lastInitial}`;
}; 